import ___svg_formatpainterSvg from '../svg/formatpainter.svg';
import { formatPainter as formatPainter_1 } from './formatPainter.locstring.json';
import loc from 'owa-localize';
import RibbonButton, { RibbonButtonState } from './RibbonButton';
import toggleFormatPainter from 'owa-editor-ribbonplugin-store/lib/actions/toggleFormatPainter';

const formatPainter: RibbonButton = {
    key: 'formatPainter',
    title: () => loc(formatPainter_1),
    imageSrc: ___svg_formatpainterSvg,
    buttonState: formatState =>
        formatState.formatPainterFormat ? RibbonButtonState.Checked : RibbonButtonState.Normal,
    onExecute: (editorViewState, formatState) => {
        toggleFormatPainter(editorViewState, formatState, !formatState.formatPainterFormat);
    },
};

export default formatPainter;
